export default __webpack_public_path__ + "static/kathi-basti_mobile-4bdb220bd3344c166172bc9ca5ec462b.png";